<picture class="page-background">
  <source media="(min-width: 840px)" srcset="assets/images/backgrounds/background-02_large.jpg" />
  <source media="(min-width: 600px)" srcset="assets/images/backgrounds/background-02_medium.jpg" />
  <source media="(max-width: 599px)" srcset="assets/images/backgrounds/background-02_small.jpg" />
  <img class="cover" src="assets/images/backgrounds/background-02_large.jpg" alt="">
</picture>
<ng-container *ngIf="email; else forgotPassword">
  <ecp-reset-temp-password [email]="email"></ecp-reset-temp-password>
</ng-container>

<ng-template #forgotPassword>
  <ng-container>
    <ecp-sent-recover-email></ecp-sent-recover-email>
  </ng-container>
</ng-template>
